import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
import "./assets/styles/styles.css";
import { configureStore } from "./redux/store";

import App from "./App";
import Dashboard from "./containers/Dashboard";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import LeftNavigation from "./components/shared/LeftNavigation";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

import { ChakraProvider } from "@chakra-ui/react";

// Sentry.init({
//   dsn: process.env.REACT_APP_SENTRY_KEY,
//   integrations: [new BrowserTracing()],
//   tracesSampleRate: 1.0,
// });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={configureStore()}>
        <ChakraProvider>
          <App />
        </ChakraProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
